if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.speed = this.getAttribute('data-speed')
      this.getCookie = (name) => {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
        }
        return null;
      };

      this.setCookie = (name, value, days) => {
        var expires = '';
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
      };
    }

    connectedCallback() {
      if (this.getCookie('announcement-bar-close')) {
        this.classList.add('hidden')
        return;
      }
      const speed = this.speed;

      const closeBtn = this.querySelector('.announcement-bar__close');

      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          console.log('cloc');
          this.classList.add('hidden')
          this.setCookie('announcement-bar-close', 'true', 30);
        })
      }

      const swiperElement = this.querySelector('.swiper');
      if (swiperElement && typeof Swiper !== 'undefined') {
        new Swiper(swiperElement, {
          direction: 'horizontal',
          autoplay: {
            delay: speed,
          },
          loop: true,
        });
      }
    }
  }
  customElements.define('announcement-bar', AnnouncementBar);
}
